import { Accordion, AccordionSummary, Box, Button, Switch } from '@material-ui/core';
import { Delete, UnfoldMore } from '@material-ui/icons';

export const ShareControl = ({ onUpdate, value, onDelete }) => {
    return (
        <div className='w-full'>
            <Accordion variant='outlined' expanded={false}>
                <AccordionSummary
                    className='handle'
                    expandIcon={<Button
                        size="small"
                        variant='contained'
                        onClick={() => onDelete()}
                        startIcon={<Delete />}
                        color='default'>
                        Remove
                    </Button>}
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                    style={{ padding: "0 5px" }}
                >
                    <Box display="flex" alignItems="center" width={"100%"}>
                        <Box display="flex" alignItems="center">
                            <UnfoldMore htmlColor='#CECECE' />&nbsp;

                            <svg
                                width="21"
                                height="21"
                                viewBox="0 0 21 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5.5129 9.00645C5.66462 8.70361 5.75 8.36178 5.75 8C5.75 7.63822 5.66462 7.29639 5.5129 6.99355M5.5129 9.00645C5.1435 9.74381 4.38086 10.25 3.5 10.25C2.25736 10.25 1.25 9.24264 1.25 8C1.25 6.75736 2.25736 5.75 3.5 5.75C4.38086 5.75 5.1435 6.25619 5.5129 6.99355M5.5129 9.00645L10.4871 11.4935M5.5129 6.99355L10.4871 4.50645M10.4871 4.50645C10.8565 5.24381 11.6191 5.75 12.5 5.75C13.7426 5.75 14.75 4.74264 14.75 3.5C14.75 2.25736 13.7426 1.25 12.5 1.25C11.2574 1.25 10.25 2.25736 10.25 3.5C10.25 3.86178 10.3354 4.20361 10.4871 4.50645ZM10.4871 11.4935C10.3354 11.7964 10.25 12.1382 10.25 12.5C10.25 13.7426 11.2574 14.75 12.5 14.75C13.7426 14.75 14.75 13.7426 14.75 12.5C14.75 11.2574 13.7426 10.25 12.5 10.25C11.6191 10.25 10.8565 10.7562 10.4871 11.4935Z"
                                    stroke="#CECECE"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>

                        </Box>
                        <div className='pl-2 text-gray-500'>
                            Share Url
                        </div>
                    </Box>
                </AccordionSummary>
            </Accordion>
        </div>
    )
}
